var _ = require('lodash');
var React = require('react');
var Reflux = require('reflux');

var storyScenarios = require('models/storyScenarios');

var ScrollSpyContentsMixin = require('views/scrollSpy/ScrollSpyContentsMixin');

var SCROLLSPY_PROPS = {
  id: 'scenario-exit',
  name: 'Exit'
}

module.exports = React.createClass({displayName: "module.exports",
  mixins: [ScrollSpyContentsMixin],

  getInitialState:function() {
    return {
      scrollSpy: SCROLLSPY_PROPS
    };
  },

  componentDidMount: function() {
    this._origExitValuation = storyScenarios.rounds.exit.valuation;
  },

  onScrollSpyFocus: function(target) {
    actions.ui.showPVScatter(true);
    actions.chart.selectMeasure('values');
    actions.exit.changeValuation(storyScenarios.rounds.exit, this._origExitValuation);
    actions.round.setScenario(storyScenarios.rounds.exit);
    actions.chart.selectRound(storyScenarios.rounds.exit);
  },

  render:function() {
    return (
      React.createElement("div", {id: SCROLLSPY_PROPS.id}, 
        React.createElement("h1", {className: this.state.scrollSpy.isFocused ? 'focus' : ''}, "The (Successful) Exit"), 
        React.createElement("p", null, 
          "And now our journey is coming to an end.  Ideally it's a happy ending — the value of the buyout, IPO," + " " +
          "or other ", React.createElement("strong", null, "liquidation event"), " is high enough that all shareholders get a positive return." + " " +
          "Pop the champagne!"
        )
      )
    );
  }
});


/** WEBPACK FOOTER **
 ** /Users/dlopuch/developer/projects-venture-dealr/~/jsx-loader?harmony!./views/scrollSpyContents/Exit.jsx
 **/